import { ERD, VmessAccountActions } from "@dots-crm/contracts/client";
import { api } from "api";
import { QueryArgsNew } from "api/api.type";
import {
  VMESS_ACCOUNT_ENDPOINTS_URLS,
  VMESS_ACCOUNT_TAGS,
} from "./api-vmess-account.constant";

export const {
  useCreateVmessAccountMutation,
  useReadManyVmessAccountsQuery,
  useDeleteVmessAccountMutation,
  useImportVmessAccountsMutation,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    createVmessAccount: builder.mutation<
      ERD<VmessAccountActions["create"]>,
      QueryArgsNew<VmessAccountActions["create"]>
    >({
      query: ({ payload }) => ({
        url: VMESS_ACCOUNT_ENDPOINTS_URLS.create,
        method: "post",
        payload,
      }),
      invalidatesTags: [VMESS_ACCOUNT_TAGS.vmessAccount],
    }),
    readManyVmessAccounts: builder.query<
      ERD<VmessAccountActions["readMany"]>,
      QueryArgsNew<VmessAccountActions["readMany"]>
    >({
      query: ({ query }) => ({
        url: VMESS_ACCOUNT_ENDPOINTS_URLS.readMany,
        method: "get",
        query,
      }),
      providesTags: [VMESS_ACCOUNT_TAGS.vmessAccount],
    }),
    deleteVmessAccount: builder.mutation<
      void,
      QueryArgsNew<VmessAccountActions["delete"]>
    >({
      query: ({ params }) => ({
        url: VMESS_ACCOUNT_ENDPOINTS_URLS.delete(params),
        method: "delete",
      }),
      invalidatesTags: [VMESS_ACCOUNT_TAGS.vmessAccount],
    }),
    importVmessAccounts: builder.mutation<
      ERD<VmessAccountActions["import"]>,
      { file: File }
    >({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: VMESS_ACCOUNT_ENDPOINTS_URLS.import,
          method: "post",
          body: formData,
        };
      },
      invalidatesTags: [VMESS_ACCOUNT_TAGS.vmessAccount],
    }),
  }),
});

export const downloadVmessAccountTemplate = async () => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";
  const accessToken = localStorage.getItem("token");
  const response = await fetch(
    `${apiUrl}/${VMESS_ACCOUNT_ENDPOINTS_URLS.importTemplate}`,
    { headers: { Authorization: accessToken || "" } }
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "vmess-accounts-template.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
};

export const downloadVmessAccountsExport = async () => {
  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:6002";
  const accessToken = localStorage.getItem("token");
  const response = await fetch(
    `${apiUrl}/${VMESS_ACCOUNT_ENDPOINTS_URLS.export}`,
    { headers: { Authorization: accessToken || "" } }
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "vmess-accounts.xlsx";
  link.click();
  window.URL.revokeObjectURL(url);
};
